module.exports = __webpack_public_path__ + "img/left_md_5.a56acb7a.jpg";